<template>
  <div>
    <loading-indicator
      v-if="isLoading"
      :useDelay="false"
    />

    <template
      v-if="info !== null"
    >

      <json-tree
        :data="info"
        :level=1
      />

      <div class="mt-3 text-center">
        <b-button @click="downloadState">Download state</b-button>
      </div>

    </template>

  </div>
</template>

<script>
import JsonTree from 'vue-json-tree';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import saveAs from 'file-saver';

export default {
  name: 'PlayerState',

  components: {
    JsonTree,
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      info: null,
    };
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;
    HTTP.get('/player/' + this.playerId + '/raw_info')
     .then(response => {
       this.info = response.data;
     })
    .catch(e => {
      notifier.showError(e.response.data, {sender: this});
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  methods: {
    downloadState() {
      HTTP.get('/player/' + this.playerId + '/state', {responseType: 'blob'})
      .then(response => {
        
        saveAs(new Blob([response.data]), 'player_state_' + this.playerId + '.dat');
        
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      })
    },
  },
};
</script>
